App.factory('subscription', ['$rootScope', 'subscriptionService', function($rootScope, subscriptionService) {
    function Subscription() {
        this.check = function() {
            subscriptionService.check().then(function (data) {
                if (data.status === 200) {
                    var time = new Date().getTime();
                    if (data.data.expirationDate >= time) {
                        $rootScope.__subscription = true;
                    } else {
                        $rootScope.__subscription = false;
                    }
                }
            });
        }
    }
    
    return new Subscription();
}]);